module.exports = __webpack_public_path__ + "img/طراحی-نرم.cfc700bc.png";